import { SchoolOutlined } from "@mui/icons-material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import { IconButton, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/aveti.png";
import useAuth from "../../contexts/UserContext.tsx";
import "./sidebar.scss";

const SidebarMathlab = () => {
  const { logout, user } = useAuth();
  const media = useMediaQuery("(max-width: 768px)");
  const [collapsed, setCollapsed] = useState(media);
  const schoolID = user.view_access_list.schoolID;
  return (
    <div
      className={
        collapsed
          ? "sidebar max-w-xs min-w-fit dark:bg-grey-50 collapsed"
          : "sidebar max-w-xs min-w-fit dark:bg-grey-50"
      }
    >
      <div className="top">
        {/* <div className="logo">5T Dashboard</div> */}
        <img src={logo} alt="logo" className="w-24 py-2 flex mx-auto" />
        {media ? (
          <div className="menuIcon">
            {
              <IconButton
                fontSize="small"
                onClick={() => setCollapsed((prev) => !prev)}
              >
                {collapsed ? <MenuIcon /> : <ArrowBackIosIcon />}
              </IconButton>
            }
          </div>
        ) : null}
      </div>
      <hr />
      <div className="center">
        <div className="menuGroup">
          <p className="title">MathLab</p>
          <ul>
            <li>
              <NavLink
                to={`/mathlab/school/${schoolID}`}
                style={{ textDecoration: "none" }}
                end
              >
                <LocalLibraryIcon className="icon" />
                <span>Student Progress</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className="w-full px-2"
                to={`/mathlab/school/${schoolID}/studentexerciseprogress`}
                style={{ textDecoration: "none" }}
              >
                <SchoolOutlined className="icon" />
                <span>Skill Progress</span>
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                className="w-full px-2"
                to={`/mathlab/school/${schoolID}/progressgrid`}
                style={{ textDecoration: "none" }}
              >
                <GridOn className="icon" />
                <span>Progress Grid</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink
                className="w-full px-2"
                to={`/mathlab/school/${schoolID}/mathlabUsers`}
                style={{ textDecoration: "none" }}
              >
                <PersonIcon className="icon" />
                <span>Mathlab Users</span>
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="menuGroup">
          <p className="title">User</p>
          <ul>
            <li>
              <button onClick={logout}>
                <ExitToAppIcon className="icon" />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SidebarMathlab;
